<template>
  <div class="checkbox__wrapper" @click="toggleState">
    <div class="checkbox" :class="{'checkbox--active': isChecked}">
      <BaseIcon icon="check" class="checkbox__icon"></BaseIcon>
    </div>
    <span v-if="text!=''">{{text}}</span>
  </div>
</template>

<script>
export default {
  name: 'BaseCheckbox',
  props: ['value', 'val', 'text'],
  data() {
    return {
      checkedProxy: null,
    };
  },
  computed: {
    checked: {
      get() {
        return this.value;
      },
      set(val) {
        this.checkedProxy = val;
      },
    },
    isChecked() {
      if (Array.isArray(this.value)) {
        if (this.val instanceof Object) {
          return this.value.some(item => item.id === this.val.id);
        } else {
          return this.value.includes(this.val);
        }
      }
      if (typeof this.value === 'boolean') return this.value;
      return false;
    },
  },
  methods: {
    toggleState() {
      if (this.isChecked) {
        if (typeof this.value === 'boolean') {
          this.change(false);
        } else if (Array.isArray(this.value)) {
          if (this.val instanceof Object) {
            const remove = this.value.filter(item => item.id !== this.val.id);
            this.change(remove);
          } else {
            const remove = this.value.filter(item => item !== this.val);
            this.change(remove);
          }
        }
      } else {
        if (typeof this.value === 'boolean') {
          this.change(true);
        } else if (Array.isArray(this.value)) {
          const push = [...this.value, this.val];
          this.change(push);
        }
      }
    },
    change(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss">
.checkbox {
  width: 2rem;
  height: 2rem;
  border: 0.2rem solid $grey;
  border-radius: 0.4rem;
  overflow: hidden;
  background-color: white;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &__wrapper {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  &:hover {
    border-color: $company-color;
  }

  &__icon {
    fill: white;
    width: 1.4rem;
    transform: scale(0);
    transition: all 0.4s;
  }

  &__text {
    margin-left: 1rem;
    color: $dark;
  }

  &--active {
    background-color: $company-color;
    border-color: $company-color;
    transition: all 0.2s;

    .checkbox__icon {
      transform: scale(1);
      transition: transform 0.4s;
    }
  }
}
</style>
